import { gsap, ScrollTrigger, SplitText } from '../global/gsap';

const initHomeHero = (section) => {
    const line = section.querySelector('.js-line');
    const title = section.querySelector('.js-title');
    const titleTl = gsap.timeline();

    if (title) {
        const split = new SplitText(title, { type: 'words' });

        gsap.set(split.words, {
            yPercent: 50,
            opacity: 0,
            transformOrigin: 'bottom left',
            rotate: 10
        });

        titleTl.pause();

        titleTl.to(split.words, {
            yPercent: 0,
            opacity: 1,
            rotate: 0,
            stagger: 0.05,
            duration: 0.5,
            ease: 'power4.out',
        });
    }

    if (line) {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: line,
                start: 'top 60%',
                end: 'bottom 60%',
                scrub: true,
            },
            onComplete: () => {
                if (title) {
                    titleTl.play();
                }
            },
        });

        tl.to(line, {
            clipPath: 'inset(0 0 0%)',
        });
    }
};

export default initHomeHero;
